import React, { Component } from "react";
import { getPriceAlertCompare } from "../../shared/requests-api";
import PubSub from "pubsub-js";
import { $ } from "../../shared/utils";
import PriceAlertRedirectModal from "./PriceAlertRedirectModal";

import "../../shared/pubsub-triggers";
import { CookieTypes, getCookie, setCookie } from "../../shared/cookie";

class PriceAlertRedirect extends Component {
    constructor(...args) {
        super(...args);
        this.state = { openModal: false, data: null };
    }

    componentDidMount() {
        const { match: { params: { id } } } = this.props;

        const pageWrapperClass = document.querySelector(".page-wrapper");

		if (pageWrapperClass) {
			pageWrapperClass.classList.add("redirect");
        }

        if ($("#loader_wrapper")) {
            setTimeout(() => {
                $("#loader_wrapper").classList.remove("visualHidden", "hidden");

                if (id) {
                    getPriceAlertCompare(id).then(response => {
                        if (response.status === 200) {
                            this.openModalAndRedirect(response.data);
                            this.sendGAEvents(response.data);
                            this.addPriceIdToCookie(id);
                        } else {
                            this.openModalAndRedirect({ result: "ERROR" });
                            this.sendGAEvents(response.data);
                        }
                    }).catch(err => {
                        const data = {
                            result: "ERROR",
                            content: err
                        };
                        
                        this.openModalAndRedirect(data);
                        this.sendGAEvents(data);
                    });
                }
            }, 900);
        }
    }

	addPriceIdToCookie(id) {
		const lastClickCookie = getCookie("last_click", CookieTypes.PUBLICITY);
		const lastClick = lastClickCookie ? JSON.parse(lastClickCookie) : undefined;

		if (lastClick && lastClick.utm_campaign === "alertadepreco") {
			lastClick.alertId = id;
			setCookie("last_click", lastClick, CookieTypes.PUBLICITY);
		}
	}

    openModalAndRedirect(response) {
        if (response.result === "OK") {
            const { checkoutUrl } = response;
            window.location = checkoutUrl || "https://www.maxmilhas.com.br";
        } else {
            $("#loader_wrapper").classList.add("visualHidden", "hidden");
            this.setState({ openModal: true, data: response });
        }
    }

    sendGAEvents(data) {
        const params = {
			event: "gaEvent",
			gaEventCategory: "Fluxo compra alerta de preço"
        };
        
        if (data.result === "OK") {
            PubSub.publish("dataLayer", {
                ...params,
                gaEventAction: "Atende as regras do alerta",
                gaEventLabel: "Mesmo voo",
                gaEventDetail: "Mesmo valor"
            });
        } else if (data.result === "INCREASE") {
            PubSub.publish("dataLayer", {
                ...params,
                gaEventAction: "Atende as regras do alerta",
                gaEventLabel: "Mesmo voo",
                gaEventDetail: "Valor maior"
            });
        } else if (data.result === "DECREASE") {
            PubSub.publish("dataLayer", {
                ...params,
                gaEventAction: "Atende as regras do alerta",
                gaEventLabel: "Mesmo voo",
                gaEventDetail: "Valor menor"
            });
        } else if (data.result === "CHANGED") {
            PubSub.publish("dataLayer", {
                ...params,
                gaEventAction: "Atende as regras do alerta",
                gaEventLabel: "Outro voo",
            });
        } else if (data.result === "EXPIRED") {
            PubSub.publish("dataLayer", {
                ...params,
                gaEventAction: "Não atende as regras do alerta",
                gaEventLabel: "Alerta expirou"
            });
        } else if (data.result === "ENDED") {
            PubSub.publish("dataLayer", {
                ...params,
                gaEventAction: "Não atende as regras do alerta",
                gaEventLabel: "Não encontrou voo"
            });
        } else if (data.result === "ERROR") {
            PubSub.publish("dataLayer", {
                ...params,
                gaEventAction: "Instabilidade técnica"
            });
        }
    }

    render() {
        const { openModal, data } = this.state;        

        return data ? (
            <PriceAlertRedirectModal
                isOpen={openModal}
                data={data}
                cssClass={["redirect-modal", "small-modal", "tingle-modal--noClose"]} />
        ) : null;
    }
}

export default PriceAlertRedirect;
